export { default, getServerSideProps } from '@adecco/base-app/pages/error';
